import client from 'src/utils/client';
import { AccountState } from '../store/account/types';

type CardLoginType = (username: string) => Promise<CardLoginResponse>;
type LoginType = (username: string, password: string) => Promise<LoginResponse>;
type GetCurrentUserType = () => Promise<User>;
type UpdateUserType = (update: Partial<AccountState['user']>) => Promise<User>;
type UpdateStringType = (update: string) => Promise<any>;
type UpdateFormDataType = (update: FormData) => Promise<User>;
type NetworkManagerSimple = { id: number; name: string };
type GetNetworkManagersType = (
  searchParams?: QueryParams
) => Promise<NetworkManagerSimple[]>;

export const cardLogin: CardLoginType = (username) =>
  client
    .post('auth/card-login', {
      json: {
        username
      }
    })
    .json();

export const loginUser: LoginType = (username, password) =>
  client
    .post('auth/login', {
      json: {
        username,
        password
      }
    })
    .json();

export const getCurrentUser: GetCurrentUserType = () =>
  client.get('auth/me').json();

export const updateProfileRequest: UpdateUserType = (update) =>
  client
    .patch('auth/me', {
      json: {
        update
      }
    })
    .json();

export const updatePasswordRequest: UpdateStringType = (update) =>
  client
    .post('auth/me/set-password', {
      json: {
        update
      }
    })
    .json();

export const updatePhotoRequest: UpdateFormDataType = (update) =>
  client
    .post('auth/me/set-photo', {
      body: update
    })
    .json();

export const getNetworkManagers: GetNetworkManagersType = (searchParams) =>
  client.get('auth/network-managers', { searchParams }).json();
